import { StepOptions } from 'shepherd.js';

export const defaultStepOptions: StepOptions = {
  classes: 'shepherd-theme-arrows custom-default-class',
  scrollTo: true,
  cancelIcon: {
    enabled: true,
  },
};

// Tours that guide the user through a modal dialog must NOT use shepherd's own
// overlay: it fights the dialog for focus (typing loses focus when the dialog
// resizes). The dialog already provides its own backdrop.
export const nonModalPageTours = ['flow-editor', 'core-node'];

// A single onboarding step, defined as data. TourService turns these into
// shepherd steps (translated title/text + navigation buttons) at runtime.
export interface TourStepDef {
  id: string;
  attachTo?: StepOptions['attachTo'];
  titleKey: string;
  textKey: string;
  // Key of a page action (passed to TourService.startForPage) to run before the
  // step shows — e.g. open a panel so the attach element exists.
  beforeShow?: string;
  // No Next button; the page advances the tour via TourService.next() once the
  // user completes an action (e.g. submits a dialog).
  waitForExternal?: boolean;
}

// Per-page tours, keyed by a stable page key. To add a tour for a page, add an
// entry here and call TourService.startForPage(<key>) on that page's mount.
export const pageTourDefs: Record<string, TourStepDef[]> = {
  flow: [
    {
      id: 'flow-eneqto-flows',
      attachTo: { element: '.active', on: 'bottom' },
      titleKey: 'tour.flow.eneqto-flows.title',
      textKey: 'tour.flow.eneqto-flows.text',
    },
    {
      id: 'flow-filtering',
      attachTo: { element: '.cap-input', on: 'bottom' },
      titleKey: 'tour.flow.filtering.title',
      textKey: 'tour.flow.filtering.text',
    },
    {
      id: 'flow-new-flow',
      attachTo: {
        element: 'div.page-layout-content-filters-right > cap-button > p-button > button.primary.cap-button',
        on: 'bottom',
      },
      titleKey: 'tour.flow.new-flow.title',
      textKey: 'tour.flow.new-flow.text',
    },
  ],
  'flow-editor': [
    {
      id: 'flow-editor-name',
      attachTo: { element: '.dialog-sm', on: 'top' },
      titleKey: 'tour.flow-editor.name.title',
      textKey: 'tour.flow-editor.name.text',
      waitForExternal: true,
    },
    {
      id: 'flow-editor-open-config',
      attachTo: { element: '[data-tour="open-config"]', on: 'bottom' },
      titleKey: 'tour.flow-editor.open-config.title',
      textKey: 'tour.flow-editor.open-config.text',
    },
    {
      id: 'flow-editor-triggers',
      attachTo: { element: '[data-tour-section="Triggers"]', on: 'left' },
      titleKey: 'tour.flow-editor.triggers.title',
      textKey: 'tour.flow-editor.triggers.text',
      beforeShow: 'openConfig',
    },
    {
      id: 'flow-editor-webhook',
      attachTo: { element: '[data-tour-node="webhook"]', on: 'left' },
      titleKey: 'tour.flow-editor.webhook.title',
      textKey: 'tour.flow-editor.webhook.text',
      beforeShow: 'openConfig',
    },
    {
      id: 'flow-editor-core',
      attachTo: { element: '[data-tour-section="Core"]', on: 'left' },
      titleKey: 'tour.flow-editor.core.title',
      textKey: 'tour.flow-editor.core.text',
      beforeShow: 'openConfig',
    },
  ],
  'core-node': [
    {
      // No attachTo: shepherd centers the step on screen.
      id: 'core-node-templating',
      titleKey: 'tour.core-node.templating.title',
      textKey: 'tour.core-node.templating.text',
    },
  ],
};
